import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ListaAlteracaoLimiteService } from './lista-alteracao-limite.service';
import { CommonService } from '../../../../shared/services/commom.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { IMyDpOptions } from 'mydatepicker';


@Component({
  selector: 'ngx-lista-alteracao-limite',
  templateUrl: './lista-alteracao-limite.component.html',
  styleUrls: ['./lista-alteracao-limite.component.scss']
})
export class ListaAlteracaoLimiteComponent implements OnInit {

  public formListaLimite = null;
  public rowData = null;
  public limiteGlobal = null;
  public funcionarioProdutoId = null;
  public balanceCardInfo = [];
  public listProdutos: any = null;

  public yesterday = new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24);
  public customLogin = null;

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    disableUntil: { year: this.yesterday.getFullYear(), month: this.yesterday.getMonth() + 1, day: this.yesterday.getDate() },

  };


  constructor(
    private formBuilder: FormBuilder,
    private service: ListaAlteracaoLimiteService,
    private commomService: CommonService,
    private router: Router,
    private notifications: NotificationsService,
  ) {

    this.service.buscaLimiteGlobal(null, (response) => {
      this.limiteGlobal = response.limiteAtual
      this.getFormattedPrice(this.limiteGlobal);
    }, null)

  }

  buscarUser(data) {

    let params = new HttpParams();

    if (data.cpf != null) {
      params = params.append('cpf', data.cpf);

    }
    if (data.matricula != null) {
      params = params.append('matricula', data.matricula);
    }
    this.service.buscaUsuario(params, (response => {
      if (response === null) {
        this.notifications.error('Funcionário com CPF ou matrícula não ATIVO.');
      } else {
        this.rowData = response
        this.funcionarioProdutoId = response[0].id;
      }
    }), (error) => {
      this.notifications.error(error.message);
    });
  }

  number(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if ((charCode == 45)) {

      this.formListaLimite.controls['limite'].setValue(null);
      this.notifications.error('Não é permitido números negativos!');

    }
    return true;

  }

  salveLimite(data) {

    let debitaEmpresa = true;
    let funcionarioProdutoId = this.funcionarioProdutoId;

    data.debitaEmpresa = debitaEmpresa;
    data.funcionarioProdutoId = funcionarioProdutoId;

    if (data.dataAgendado != null) {
      let dataAgendado = this.getDateTimestamp(data.dataAgendado);
      data.dataAgendado = dataAgendado;

    }

    let register = {

      dataAgendamento: data.dataAgendado,
      debitaEmpresa: data.debitaEmpresa,
      funcionarioProdutoId: data.funcionarioProdutoId,
      limite: data.limite,

    }


    this.service.scheduleCharge(
      register,
      (resp) => {
        this.notifications.success('Registro Salvo com sucesso!');
        this.limparForm();

        this.service.buscaLimiteGlobal(null, (response) => {
          this.limiteGlobal = response.limiteAtual
          this.getFormattedPrice(this.limiteGlobal);
        }, null)

      }, (error) => {
        this.notifications.error(error.message);
      })

  }

  limparForm() {
    this.formListaLimite = this.formBuilder.group({
      cpf: [null],
      matricula: [null],
      novoSalario: [null],
      dataAgendado: [null],
      limite: [null],

    });

    this.rowData = null;

  }

  getDateTimestamp(data) {
    let dataReturn = null;
    if ('jsdate' in data) {
      dataReturn = new Date(data.jsdate)
      dataReturn = moment(dataReturn).format('YYYY-MM-DD');
    } else {
      dataReturn = new Date(data.date['year'], data.date['month'] - 1, data.date['day']).getTime();
      dataReturn = moment(dataReturn).format('YYYY-MM-DD');
    }

    return dataReturn;
  }


  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.commomService.buscaProdutos().subscribe(response => {
      this.listProdutos = response
      this.listProdutos.forEach(produto => {
        if (produto.produtoDescricao === 'ADIANTA') {
          produto['taxaDescricao'] = 'TARIFA_EMISSAO_USUARIO_CONVENIO_BANDEIRADO'
          this.balanceCardInfo.push({
            'descricao': produto.produtoDescricao,
            'saldoAtual': produto.limiteGlobalAtual,
            'custoImportacao': 0,
            'icon': 'far fa-money-bill-alt',
            'type': 'primary',
            'selected': false,
            'taxaDescricao': 'TARIFA_EMISSAO_USUARIO_CONVENIO_BANDEIRADO'

          })
        }
      });
    });

    this.formListaLimite = this.formBuilder.group({
      cpf: [null],
      matricula: [null],
      novoSalario: [null],
      dataAgendado: [null, Validators.required],
      limite: [null, Validators.required],

    });

  }

  numberOnly(event) {

    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 97) && (charCode <= 122)) {
      return false;
    }
    return true;

  }

  getFormattedPrice(limiteGlobal) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(limiteGlobal);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
